import z from "zod";

const translationPath = "page.4uDlist.generationRule.doctor.errors.";

export const doctorSchema = z.object({
  id: z.string().optional(),
  sector: z.string().min(1, translationPath + "sector"),
});

export type TDoctorForm = z.infer<typeof doctorSchema>;
